import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';
import {Body} from 'shells/typography/body';

import {Setting} from '../../../core/setting';

// Matches Nut/Mail/SendForUser.php setting
const EMAIL_SEND_FROM_DEFAULT_APP = 'sendforuser_mailto_enabled';
const DEFAULT_VALUE = '0';

type Props = {
    onError: (arg1: string) => void;
    disabled: boolean;
};

export function EmailAddressClickActionSetting(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<string | null | undefined>(null);
    const savedTimeoutRef = React.useRef();

    return (
        <Setting settingName={EMAIL_SEND_FROM_DEFAULT_APP}>
            {/* @ts-expect-error */}
            {(emailDefaultActionSetting) => {
                if (emailDefaultActionSetting.setting) {
                    const initialLoading = emailDefaultActionSetting.setting === undefined;
                    let selectedValue = initialLoading ? null : DEFAULT_VALUE;
                    if (
                        emailDefaultActionSetting.setting &&
                        emailDefaultActionSetting.setting.value !== null
                    ) {
                        selectedValue = emailDefaultActionSetting.setting.value;
                    }
                    const disabled =
                        props.disabled ||
                        emailDefaultActionSetting.isLoading ||
                        emailDefaultActionSetting.isUpdating;

                    return (
                        <RadioGroup
                            name='email action'
                            selectedValue={selectedValue}
                            onChange={(newVal) => {
                                emailDefaultActionSetting
                                    .updateSetting(newVal)
                                    .then((mutationResult) => {
                                        const sendFromNutshellEnabledValue =
                                            mutationResult &&
                                            mutationResult.data &&
                                            mutationResult.data.updateSetting &&
                                            mutationResult.data.updateSetting.setting.value;
                                        setValueSaved(sendFromNutshellEnabledValue);

                                        NutClientConfig.sendFromNutshellEnabled = Boolean(
                                            Number(sendFromNutshellEnabledValue)
                                        );

                                        if (savedTimeoutRef.current) {
                                            clearTimeout(savedTimeoutRef.current);
                                        }
                                        // @ts-expect-error
                                        savedTimeoutRef.current = setTimeout(() => {
                                            setValueSaved(null);
                                        }, 1000);
                                    })
                                    .catch((errMsg) => {
                                        props.onError(errMsg);
                                    });
                            }}
                        >
                            <SavedSettingToast state={valueSaved === '1' ? 'complete' : 'initial'}>
                                <Radio value='1' disabled={disabled}>
                                    <Body>Send an email from inside of Nutshell</Body>
                                </Radio>
                            </SavedSettingToast>
                            <SavedSettingToast state={valueSaved === '0' ? 'complete' : 'initial'}>
                                <Radio value='0' disabled={disabled}>
                                    <Body>Send an email from my default email application</Body>
                                </Radio>
                            </SavedSettingToast>
                        </RadioGroup>
                    );
                }

                return null;
            }}
        </Setting>
    );
}
